// 车型高级弹窗配置
export const carTypeNameCnConfig = {
    name: '车型',
    advanceLabel: '选择车型',
    value: 'lengthNameCn',
    advanceConfig: [
        { prop: 'lengthNameCn', value: '车型' },
        { prop: 'length', value: '车型编码' }
    ],
    tableConfig: [
        { prop: 'lengthNameCn', value: '车型' },
        { prop: 'length', value: '车型编码' }
    ],
    type: 'advance',
    prefix: '/api-srm-web/supplier',
    advanceUrl: '/supplierCarLength/standardCarType/getPage',
    cbParams: [
        'lengthNameCn#lengthNameCn',
        'length#length'
    ]
}

